export const version = '1.1.4';
//# sourceMappingURL=version.js.map